import { createSSRApp } from 'vue';
import { createHead, VueHeadMixin } from '@unhead/vue';
import Datepicker from '@rei/date-picker';
import SearchPageComponent from './SearchPageComponent.vue';
import createStore from '../../stores/root';
import moduleFac from '../../stores/opoSearch';

const moduleName = 'opo-search';
const store = createStore(moduleName, moduleFac(moduleName), SearchPageComponent);

export default function createApp(props) {
  const head = createHead();
  const app = createSSRApp(SearchPageComponent, props);

  app.use(head);
  app.use(Datepicker);
  app.use(store);
  app.mixin(VueHeadMixin);

  return { app };
}
